import React, { useState } from "react";

export default function AddProduct() {
  const [formData, setFormData] = useState({
    name: "",
    category: "",
    uom: "",
    price: "",
    image: null,
    status: "",
  });
  const [errors, setErrors] = useState({});

  const categories = ["Fruits", "Vegetables", "Dairy"]; // Example options
  const uoms = ["kg", "liters", "units"];
  const statuses = ["Available", "Unavailable"];

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleFileChange = (e) => {
    setFormData({ ...formData, image: e.target.files[0] });
  };

  const validateInputs = () => {
    const errors = {};
    if (!formData.name.trim()) errors.name = "Product name is required";
    if (!formData.category) errors.category = "Category is required";
    if (!formData.uom) errors.uom = "Unit of measure is required";
    if (!formData.price || isNaN(formData.price)) errors.price = "Valid price is required";
    if (!formData.status) errors.status = "Status is required";
    setErrors(errors);
    return Object.keys(errors).length === 0;
  };

  const handleSubmit = () => {
    if (validateInputs()) {
      console.log("Product submitted:", formData);
      // Submission logic
    }
  };

  return (
    <div className="bg-white shadow-lg rounded-lg p-6 max-w-4xl mx-auto">
      <div className="flex flex-col">
        <div className="flex flex-row items-center justify-between p-4 bg-gray-200 rounded-t-lg">
          <h3 className="font-semibold text-lg text-gray-700">New Product</h3>
          <button
            className="text-lightBlue-500 bg-transparent border border-solid border-lightBlue-500 hover:bg-lightBlue-500 hover:text-white active:bg-lightBlue-600 font-bold uppercase text-xs px-4 py-2 rounded outline-none focus:outline-none ease-linear transition-all duration-150"
            type="button"
            onClick={handleSubmit}
          >
            Save
          </button>
        </div>
        <form className="p-4 space-y-6">
          {/* Name */}
          <div className="relative flex w-full flex-wrap items-stretch mb-3">
            <span className="z-10 h-full leading-snug font-normal absolute text-center text-blueGray-300 bg-transparent rounded text-base items-center justify-center w-8 pl-2 py-1">
              <i className="fas fa-box"></i>
            </span>
            <input
              type="text"
              name="name"
              placeholder="Product Name"
              className="px-2 py-1 placeholder-blueGray-500 text-gray-700 bg-white rounded text-sm border border-blueGray-300 outline-none focus:outline-none focus:shadow-outline w-full pl-10"
              value={formData.name}
              onChange={handleInputChange}
            />
            {errors.name && <p className="text-red-500 text-xs mt-1">{errors.name}</p>}
          </div>
          {/* Category */}
          <div className="relative flex w-full flex-wrap items-stretch mb-3">
            <select
              name="category"
              className="px-2 py-1 text-gray-700 bg-white rounded text-sm border border-blueGray-300 outline-none focus:outline-none focus:shadow-outline w-full"
              value={formData.category}
              onChange={handleInputChange}
            >
              <option value="">Select Category</option>
              {categories.map((cat, index) => (
                <option key={index} value={cat}>
                  {cat}
                </option>
              ))}
            </select>
            {errors.category && <p className="text-red-500 text-xs mt-1">{errors.category}</p>}
          </div>
          {/* UOM */}
          <div className="relative flex w-full flex-wrap items-stretch mb-3">
            <select
              name="uom"
              className="px-2 py-1 text-gray-700 bg-white rounded text-sm border border-blueGray-300 outline-none focus:outline-none focus:shadow-outline w-full"
              value={formData.uom}
              onChange={handleInputChange}
            >
              <option value="">Select Unit of Measure</option>
              {uoms.map((unit, index) => (
                <option key={index} value={unit}>
                  {unit}
                </option>
              ))}
            </select>
            {errors.uom && <p className="text-red-500 text-xs mt-1">{errors.uom}</p>}
          </div>
          {/* Price */}
          <div className="relative flex w-full flex-wrap items-stretch mb-3">
            <span className="z-10 h-full leading-snug font-normal absolute text-center text-blueGray-300 bg-transparent rounded text-base items-center justify-center w-8 pl-2 py-1">
              <i className="fas fa-dollar-sign"></i>
            </span>
            <input
              type="number"
              name="price"
              placeholder="Price"
              className="px-2 py-1 placeholder-blueGray-500 text-gray-700 bg-white rounded text-sm border border-blueGray-300 outline-none focus:outline-none focus:shadow-outline w-full pl-10"
              value={formData.price}
              onChange={handleInputChange}
            />
            {errors.price && <p className="text-red-500 text-xs mt-1">{errors.price}</p>}
          </div>
          {/* Image */}
          <div className="relative flex w-full flex-wrap items-stretch mb-3">
            <input
              type="file"
              name="image"
              className="px-2 py-1 text-gray-700 bg-white rounded text-sm border border-blueGray-300 outline-none focus:outline-none focus:shadow-outline w-full"
              onChange={handleFileChange}
            />
            {errors.image && <p className="text-red-500 text-xs mt-1">{errors.image}</p>}
          </div>
          {/* Status */}
          <div className="relative flex w-full flex-wrap items-stretch mb-3">
            <select
              name="status"
              className="px-2 py-1 text-gray-700 bg-white rounded text-sm border border-blueGray-300 outline-none focus:outline-none focus:shadow-outline w-full"
              value={formData.status}
              onChange={handleInputChange}
            >
              <option value="">Select Status</option>
              {statuses.map((status, index) => (
                <option key={index} value={status}>
                  {status}
                </option>
              ))}
            </select>
            {errors.status && <p className="text-red-500 text-xs mt-1">{errors.status}</p>}
          </div>
        </form>
      </div>
    </div>
  );
}
